import { Box, Hidden } from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import QuoteCartPayActions from "./QuoteCartPayActions";
import { QuoteHr } from "../../quotePage/components/QuoteHr";
import QuoteCartProductSubscription from "./QuoteCartProductSubscription";
import { ProductSubscription } from "../../../api/Product/ProductSubscriptionApi";
import { EventSlot } from "../../../api/EventSlot/EventSlot";
import QuoteRightInfo from "../../quotePage/components/QuoteRightInfo";

interface Props {
  quote: Quote;
  subscriptions?: ProductSubscription[];
  onRemoveSubscription: (subscription: ProductSubscription) => void;
  onAddSubscription: (subscription: ProductSubscription) => void;
  selectedEventSlot?: EventSlot | null;
  onPay: Function;
  onApplyPromoCode: (promoCode: string) => void;
  onDeletePromoCode: (quoteDeductionId: string) => void;
}

const QuoteCartRightAction = ({
  quote,
  subscriptions,
  onRemoveSubscription,
  onAddSubscription,
  selectedEventSlot,
  onPay,
  onApplyPromoCode,
  onDeletePromoCode
}: Props) => {
  return (
    <Box>
      <QuoteRightInfo
        selectedEventSlot={selectedEventSlot}
        quote={quote}
        onApplyPromoCode={onApplyPromoCode}
        onDeletePromoCode={onDeletePromoCode}
      />
      <QuoteHr mt={2} mb={2} />
      <Hidden lgUp>
        <QuoteCartProductSubscription
          quote={quote}
          subscriptions={subscriptions}
          onRemoveSubscription={onRemoveSubscription}
          onAddSubscription={onAddSubscription}
        />
      </Hidden>

      <QuoteCartPayActions quote={quote} onPay={onPay} />
    </Box>
  );
};

export default QuoteCartRightAction;
